import { Application } from 'stimulus';

require.context('../images', true);
require('@rails/ujs').start();

import '@ramseyinhouse/feedback-component';
import '../src/stylesheets/application';
import '../src/javascripts/accordionInitializer';
import stickyController from '../src/javascripts/stickyController';
import feedbackController from '../src/javascripts/feedbackController';
import ClampController from '../src/javascripts/ClampController';
import apopheniaDeclarativeLogger from '../src/javascripts/apopheniaDeclarativeLogger';
import InlineInterviewController from '../src/javascripts/InlineInterviewController';
import CallProController from '../src/javascripts/CallProController';

const application = Application.start();
application.register('clamp', ClampController);
application.register('inline-interview', InlineInterviewController);
application.register('call-pro', CallProController);

import shareLinkController from '../src/javascripts/shareLinkController';

stickyController();
feedbackController();
shareLinkController();
apopheniaDeclarativeLogger();

/**
 * If we're on a results page, store the RFID in local storage for
 * use on subsequent page navigations. We need to take this approach due to the
 * possibility that the embedded window.ELP_RFID variable is cached from a previous view.
 */
const rfid = window.location.href.match(/(?:rfid)\w{12}/i);

if (rfid) {
  window.localStorage.setItem('trusted:real_estate:rfid', rfid[0]);
}
